// Modules
import { createSelector } from '@reduxjs/toolkit'

// Store
import selfSelector from './self'

export const signalsSelector = createSelector(selfSelector, (self) => self.signals)

export const shownSignalsSelector = createSelector(selfSelector, (self) => self.shownSignals)
